import type { FC, ReactNode } from "react";

import { Container } from "@aviary";

import * as styles from "./PageContent.styles";

interface Props {
  children: ReactNode;
}

const PageContent: FC<Props> = ({ children, ...rest }) => {
  return (
    <main css={styles.main} id="main-content" role="main" tab-index="0">
      <Container css={styles.container} {...rest}>
        {children}
      </Container>
    </main>
  );
};

export { PageContent };
